const config = {
    success: '成功申请提交。',
    Application_No: '阁下申请编号为',
    notice: '「 确认电邮通知 」已发往所登记之电邮邮箱',
    return: '返回系统主页',
    // Gabriel End Here 29-May-2023
};
export default config;
